export default __webpack_public_path__ + "static/media/screen9.4cf7bf6f.png";